import store from 'store';

import logger from 'js/app/loggerSingleton';

if (store.enabled) {
  // @ts-expect-error TSMIGRATION
  store.setIfEnabled = store.set;
  const _serialize = store.serialize;
  const identity = function (value: string) {
    return value;
  };

  /**
   * Set values in local storage without serialization
   *
   * @param  {String} key   input key
   * @param  {String} value input value
   * @return {String}       serialized value
   */
  // @ts-expect-error TSMIGRATION
  store.setUnserialized = function (key: string, value: string): string {
    store.serialize = identity;
    // @ts-expect-error TSMIGRATION
    const returnValue = store.setIfEnabled(key, value);
    store.serialize = _serialize;
    return returnValue;
  };
} else {
  logger.warn('localStorage.set is disabled and some features may not work');
  // @ts-expect-error TSMIGRATION
  store.setIfEnabled = function () {};
  // @ts-expect-error TSMIGRATION
  store.setUnserialized = function () {};
}

export default store;
